








































































import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class BaseCheckbox extends Vue {
  /**
   * State of the checkbox
   * @values true, false
   */
  @Prop({ required: true, type: Boolean })
  private selected!: boolean;

  /**
   * Checkbox label, optional
   */
  @Prop({ type: String })
  private label!: string;
}
